import { BookingFormValues } from "PFApp/booking/components/booking_form/booking_form_values.types";
import { Flex } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import { Tooltip } from "PFComponents/tooltip";
import { Typography } from "PFComponents/typography";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";

import css from "./bulk_select_item.module.scss";
import { getProfilesLimit } from "./workforce_member_select.utils";

type BulkSelectItemProps = {
  count: number;
  disabled: boolean;
};

export const BulkSelectItem = ({ count, disabled }: BulkSelectItemProps) => {
  const { t } = useTranslation("bookingModule");
  const bookingType = useWatch<BookingFormValues, "bookingType">({
    name: "bookingType"
  });

  const content = (
    <Flex alignItems="center" justifyContent="start">
      <div className={css.icon}>
        <Icon name="filter" />
      </div>
      <div>
        <Typography textOverflow="clip" variant="bodyBold">
          {t("bookings.create.bulk.title")}
        </Typography>
        <Typography textOverflow="clip" variant="labelRegular" tag="p">
          {t("bookings.create.bulk.select", { count })}
        </Typography>
      </div>
    </Flex>
  );

  const limit = getProfilesLimit(bookingType);
  return disabled ? (
    <Tooltip content={t("bookings.create.bulk.tooManyProfiles", { count: limit })}>{content}</Tooltip>
  ) : (
    content
  );
};
